'use client';

import Checkbox from '../../../atoms/Checkbox/Checkbox';
import { getValidationResponse } from '../utils';
import type { CheckboxField } from '../types';
import type { UseFormRegister, UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form';

export type CheckboxControlProps = {
  field: CheckboxField;
  theme: 'dark' | 'light';
  direction: 'ltr' | 'rtl';
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  errors: FieldErrors<FieldValues>;
};

/**
 * Form control for checkbox fields
 * @component
 * @param {CheckboxControlProps} props - Component props
 * @returns {JSX.Element} Checkbox control component
 */
const CheckboxControl = ({
  field,
  theme,
  direction,
  register,
  setValue,
  errors,
}: CheckboxControlProps) => {
  return (
    <Checkbox
      key={`form_field_${field.name}`}
      theme={theme}
      name={field.name}
      label={field.label}
      dataTestId={`checkbox-${field.name}`}
      gaComponent=""
      register={() =>
        register(field.name, {
          required: field.required ? field.validationMessages?.required : false,
        })
      }
      handleChange={(isChecked) => setValue(field.name, isChecked, { shouldValidate: true })}
      validationResponse={getValidationResponse({ field: field.name, errors })}
      direction={direction}
    />
  );
};

export default CheckboxControl;
